import { render } from "./AccountPendingPage.vue?vue&type=template&id=5ed16bb8&scoped=true"
import script from "./AccountPendingPage.vue?vue&type=script&lang=js"
export * from "./AccountPendingPage.vue?vue&type=script&lang=js"

import "./AccountPendingPage.vue?vue&type=style&index=0&id=5ed16bb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed16bb8"]])

export default __exports__